// import * as React from "react";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { useLocation } from "react-router-dom";
// import Tooltip from '@material-ui/core/Tooltip';
import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";
import PropTypes from "prop-types";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
// import Checkbox from "@mui/material/Checkbox";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import React from "react";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
// import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import {
  BlockChain,
  DRCoreApi,
  DownloadApi,
  FileLoader,
  GetTokenApi,
  UploadApi,
  ViewerURL,
  keyImages,
} from "../constants/Constants";
import UploadFiles from "../pages/newUploadFile";
// import { SmileOutlined } from "@ant-design/icons";
// import getDCMCloudUrl from "../utilities/BaseKey";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Buffer } from "buffer";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CustomizedSnackbars from "./CustomizedSnackbars";
import DatatablePage from "./DatatablePage";
// import SimCardDownloadOutlinedIcon from "@mui/icons-material/SimCardDownloadOutlined";
import axios from "axios";
import imglogo from "../asstes/AddFolder.png";
import imga from "../asstes/FIleIcon.png";
// import { CircularProgress } from "@mui/material";
import { Delete, Image } from "@mui/icons-material";
import GetAppIcon from "@mui/icons-material/GetApp";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import UploadIcon from "@mui/icons-material/Upload";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import cogoToast from "cogo-toast";
import { IoMdShare } from "react-icons/io";
import { MdDelete, MdEdit } from "react-icons/md";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import checkBox from "../../src/asstes/checkBox.png";
import FOLDER from "../../src/asstes/Folder2.png";
import {
  default as FolderImg1,
  default as FolderImg2,
} from "../../src/asstes/FolderIcon.png";
import LeftArrow from "../../src/asstes/LeftArrow.png";
import {
  fileLength,
  foldersave,
  setModalFolder,
  setbuttonTop,
} from "../app/features/counterSlice";
import {
  AWS_Access_Key_Id,
  AWS_Access_Key_Id_Encypt,
  AWS_Bucket_Name,
  AWS_Region,
  AWS_Secret_Access_Key,
  AWS_Secret_Access_Key_Encypt,
} from "../constants/bucketCostant";
import AlertDialogSlide3 from "./AlertDialogSlide3";
import Loader from "./Loader";
import ImagesSidePanel from "./ModCardPanel/ImagesSidePanel";
import SidePanel from "./ModCardPanel/SidePanel";

const rows = [];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Patient name",
  },
  {
    id: "mrn",
    numeric: false,
    disablePadding: false,
    label: "MRN",
  },
  {
    id: "Accession",
    numeric: false,
    disablePadding: false,
    label: "Accession",
  },
  {
    id: "Study Date",
    numeric: false,
    disablePadding: false,
    label: "Study Date",
  },
  {
    id: "modality",
    numeric: false,
    disablePadding: false,
    label: "Modality",
  },
  {
    id: "bucket",
    numeric: false,
    disablePadding: true,
    label: "Bucket",
  },
];

const columns = [
  {
    label: "Patient Name",
    field: "name",
    sort: "asc",
    width: 150,
  },
  {
    label: "MRN",
    field: "mrn",
    sort: "asc",
    width: 100,
  },
  {
    label: "Accession",
    field: "Accession",
    sort: "asc",
    width: 100,
  },
  {
    label: "Study Date",
    field: "Study Date",
    sort: "asc",
    width: 100,
  },
  {
    label: "Modality",
    field: "modality",
    sort: "asc",
    width: 100,
  },
  {
    label: "Bucket",
    field: "bucket",
    sort: "asc",
    width: 100,
  },
  {
    label: "Actions",
    field: "action",
    sort: "asc",
    width: 70,
  },
];

function EnhancedTableHead1(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const [studies, setStudies] = React.useState([]);
  const [studiesdata, setstudiesdata] = React.useState([]);

  const [rows, setRows] = React.useState("");
  const state = useSelector((state) => state.user);

  // React.useEffect(() => {

  // }, [])

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          {/* <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    /> */}
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              <b>{headCell.label}</b>
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead1.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <>
      <Typography
        sx={{ flex: "1 1 100%" }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Study List
      </Typography>
      <Toolbar
        sx={{
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          ...(numSelected > 0 && {
            bgcolor: (theme) =>
              alpha(
                theme.palette.primary.main,
                theme.palette.action.activatedOpacity
              ),
          }),
        }}
      >
        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ) : (
          ""
        )}
      </Toolbar>
    </>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function ModalityByLabs({
  setIframeValue,
  setDisplayIFrame,
  setTab,
  setPassword,
  filterValue,
}) {
  // const { modality } = useParams();
  const label = { inputProps: { "aria-label": "WithoutModality" } };
  const labelValue = label.inputProps["aria-label"];

  const dispatch = useDispatch();

  // const [Filter, setFilter] = React.useState([]);
  const navigate = useNavigate();
  const studiesSelector = useSelector((state) => state);
  // //console.log(studiesSelector, "studiesSelector");
  // alert()

  const [Filter, setFilter] = useState("");
  const [formation, setformation] = React.useState([]);
  const FolderGet = useSelector((state) => state.FolderGet.FolderName);

  const canShare = useSelector((state) => state.canShare);
  const CanUpload = useSelector((state) => state.isUpload);
  const isOnlyKeyImages = useSelector((state) => state.isOnlyKeyImages);
  const [sortedFolderList, setFolderList] = React.useState([]);

  const [showModalityWithoutLabs, setShowModalityWithoutLabs] = useState(false);
  const { FolderName, subFolder, thirdFolder, fourthFolder } = useParams();
  let aa = useParams();
  const Folder = FolderName.split("%");
  // //console.log(aa,"subFoldersubFolder");
  // Join the Folder back together to get the cleaned value
  const cleanedValue = Folder?.join("");

  const [cOpen1, setCOpen1] = React.useState(false);
  const [shareFolderName, setShareFolderName] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const [severity, setSeverty] = React.useState("success");
  const [message, setMessage] = React.useState("");
  const [toggle, setToggle] = React.useState(true);
  const state = useSelector((state) => state.user);
  const [open, setopen] = useState(false);
  const [ssuid, setSsuid] = React.useState("");
  const [keyImagesData, setKeyImagesData] = React.useState([]);
  const [isSidePanelOpen, setIsSidePanelOpen] = React.useState(false);
  const [isImagesSidePanelOpen, setImagesSidePanelOpen] = React.useState(false);
  const [emailValue, setEmailValue] = React.useState("");
  const [createfoler, setCreteFolder] = React.useState([]);
  const [hoveredFolder, setHoveredFolder] = React.useState(null);
  const [EditModal, setEditModal] = React.useState(false);
  const [EditValue, setEditValue] = React.useState("");
  const [oldKey, setOldKey] = React.useState("");
  const token = localStorage.getItem("token");
  const [loader, setLoader] = useState(false);
  const [folderLoader, setFolderLoader] = useState(false);
  const [hide, setHide] = useState(false);
  const [ErrorMassage, setErrorMassage] = React.useState("");
  const [mainFolder, setMainFolder] = useState(false);
  const [deleteName, setDeleteName] = React.useState("");
  const [studiesHave, setStudiesHave] = React.useState(false);
  const [random, setRandom] = useState(false);
  const RefreshLoader = useSelector((state) => state.RefreshLoader);
  const [filteredSubList, setFilteredSubList] = useState([]);
  const [ifTime, setIfTime] = useState("");
  // //console.log(RefreshLoader,"RefreshLoaderRefreshLoader");
  const modalFolder = useSelector((state) => state.modalFolder);

  // Avoid a layout jump when reaching the last page with empty rows.
  // const getData = async () => {
  //   // setLoader(true);
  //   const formdata = new FormData();
  //   formdata.append(
  //     "folderName",
  //     `${FolderName}${subFolder != undefined ? "/" + subFolder : ""}`
  //   );
  //   formdata.append("bucketName", "dcm-cloud");

  //   try {
  //     let response = await axios.post(
  //       "http://localhost:5002/api/getLastUpdated",
  //       formdata,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     //console.log(response, "formdataformdata");
  //     if (response) {
  //       setIfTime(formatDateTime(response.data?.lastUpdatedTime));
  //     }
  //   } catch (error) {
  //     console.error(
  //       "Error:",
  //       error.response ? error.response.data : error.message
  //     );
  //   } finally {
  //     // setLoader(false);
  //   }
  // };

  const formatDateTime = (datetime) => {
    const date = new Date(datetime);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { formattedDate, formattedTime };
  };

  // React.useEffect(() => {
  //   if (deleteName) {
  //     if (studiesHave) {
  //       deleteNow(deleteName);
  //     } else {
  //       alert(`You need to delete data first from " ${deleteName} "`);
  //     }
  //   }
  // }, [studiesHave, deleteName, random]);

  const filesLength = useSelector((state) => state.fileLength);

  const goBack = () => {
    // Use navigate to go back to the previous page
    // navigate(`/dynamicModality/${lab}`);
    // setToggle(true);
    if (filesLength > 0) {
      let confirmExit = window?.confirm(
        "If you close this tab, the file upload will be interrupted. Are you sure you want to close this tab?"
      );
      if (confirmExit) {
        dispatch(fileLength(0));
        setMainFolder(false);
        if (FolderGet?.includes("/")) {
          navigate("/");
          dispatch(setbuttonTop(false));
          setTab(0);
          setDisplayIFrame(false);
        } else if (
          window.location.href.includes(encodeURIComponent(thirdFolder))
        ) {
          setTab(4);
          setDisplayIFrame(false);
          navigate(
            `/SubFolder&studies/${Folder}${thirdFolder ? "/" + subFolder : ""}${
              fourthFolder ? "/" + thirdFolder : ""
            }`
          );
          dispatch(setbuttonTop(false));
        } else if (
          window.location.href.includes(encodeURIComponent(subFolder))
        ) {
          setTab(4);
          setDisplayIFrame(false);
          navigate(
            `/SubFolder&studies/${Folder}${thirdFolder ? "/" + subFolder : ""}`
          );
          dispatch(setbuttonTop(false));
        } else {
          navigate("/");
          dispatch(setbuttonTop(false));
          setTab(0);
          setDisplayIFrame(false);
        }
      }
    } else {
      setMainFolder(false);
      if (FolderGet?.includes("/")) {
        navigate("/");
        dispatch(setbuttonTop(false));
        setTab(0);
        setDisplayIFrame(false);
      } else if (
        window.location.href.includes(encodeURIComponent(thirdFolder))
      ) {
        setTab(4);
        setDisplayIFrame(false);
        navigate(
          `/SubFolder&studies/${Folder}${thirdFolder ? "/" + subFolder : ""}${
            fourthFolder ? "/" + thirdFolder : ""
          }`
        );
        dispatch(setbuttonTop(false));
      } else if (window.location.href.includes(encodeURIComponent(subFolder))) {
        setTab(4);
        setDisplayIFrame(false);
        navigate(
          `/SubFolder&studies/${Folder}${thirdFolder ? "/" + subFolder : ""}`
        );
        dispatch(setbuttonTop(false));
      } else {
        navigate("/");
        dispatch(setbuttonTop(false));
        setTab(0);
        setDisplayIFrame(false);
      }
    }
  };

  // const goBack = () => {
  //   // Use navigate to go back to the previous page
  //   // navigate(`/dynamicModality/${lab}`);
  //   setToggle(false);
  //   setMainFolder(false);
  //   if (window.location.href.includes(subFolder)) {
  //     setTab(4);
  //     setDisplayIFrame(false);
  //     navigate(`/SubFolder&studies/${Folder}`);
  //     dispatch(setbuttonTop(false));
  //   } else {
  //     navigate("/");
  //     dispatch(setbuttonTop(false));
  //     setTab(0);
  //     setDisplayIFrame(false);
  //   }
  // };

  const downloadDicom = async (studyInstanceUID, e) => {
    const bucket = localStorage.getItem("currentbucket");

    const parsedData = JSON.parse(bucket);
    const requestBody = {
      args: [studyInstanceUID, state.email],
      email: state.email,
      orgName: "patient",
      fcn: "downloadDicomFile",
    };

    try {
      // const response = await axios.post(
      //   `${BlockChain}/api/give-access`,
      //   requestBody,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${token}`,
      //     },
      //   }
      // );
    } catch (error) {
      console.error(error);
    }

    let csvURL = `${DownloadApi}/dicomzip?Bucket=${encodeURIComponent(
      AWS_Bucket_Name()
    )}&path=${Folder}${subFolder ? "/" + subFolder : ""}${
      thirdFolder ? "/" + thirdFolder : ""
    }${
      fourthFolder ? "/" + fourthFolder : ""
    }/${studyInstanceUID}&region=${encodeURIComponent(
      AWS_Region()
    )}`;

    var tempLink = document.createElement("a");
    tempLink.href = csvURL;
    tempLink.click();
  };

  const saveStudyData = (modality, MainFolder) => {
    setHide(false);
    if (MainFolder === "#####") {
      navigate(
        `/SubFolder&studies/${Folder}/${subFolder}/${thirdFolder}/${modality}`
      );
      dispatch(setbuttonTop(true));
      setTab(4);
    } else if (MainFolder === "####") {
      navigate(`/SubFolder&studies/${Folder}/${subFolder}/${modality}`);
      dispatch(setbuttonTop(true));
      setTab(4);
    } else if (MainFolder === "###") {
      // localStorage.setItem("ParentFolder", Folder);
      navigate(`/SubFolder&studies/${Folder}/${modality}`);
      dispatch(setbuttonTop(true));
      setTab(4);
    } else if (!subFolder) {
      navigate(`/StudyTable/${modality}/${MainFolder}`);
      dispatch(setbuttonTop(true));
    } else if (thirdFolder) {
      navigate(
        `/StudyTable/${MainFolder}/${modality}${
          subFolder ? "/" + subFolder : ""
        }${thirdFolder ? "/" + thirdFolder : ""}`
      );
      dispatch(setbuttonTop(true));
    } else if (fourthFolder) {
      navigate(
        `/StudyTable/${MainFolder}/${modality}${
          subFolder ? "/" + subFolder : ""
        }${thirdFolder ? "/" + thirdFolder : ""}${
          fourthFolder ? "/" + fourthFolder : ""
        }`
      );
      dispatch(setbuttonTop(true));
    } else {
      navigate(
        `/StudyTable/${MainFolder}/${modality}${
          subFolder ? "/" + subFolder : ""
        }`
      );
      dispatch(setbuttonTop(true));
    }
    // const filteredDataMod = studies.filter( );
    // setTab(4)
  };

  // //console.log(lab, "lab");

  const fetchDataFromApi = async (dataa) => {
    // setLoader(true);
    const token = localStorage.getItem("token");
    const requestBody = {
      args: [dataa],
      email: state.email,
      orgName: "dcm",
      fcn: "viewDocument",
    };

    try {
      let token = localStorage.getItem("token");
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const formData = {
        AwsBucket: AWS_Bucket_Name(),
        suid: `${Folder}${subFolder ? "/" + subFolder : ""}${
          thirdFolder ? "/" + thirdFolder : ""
        }${fourthFolder ? "/" + fourthFolder : ""}/${dataa}/Reports`,
      };

      const response = await axios.post(
        `${keyImages}/keyImages/v1/PdfNode/getPdf`,
        JSON.stringify(formData),
        { headers }
      );

      if (response) {
        // setLoader(false);
        toggleSidePanel(response.data);
        // setApiData(response.data);
        setMessage("Folder Updated Successfully");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Error while deleting folder:", error);
    }
    try {
      // const response = await axios.post(
      //   `${BlockChain}/api/view-document`,
      //   requestBody,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
    } catch (error) {
      console.error(error);
    }
  };

  const fetchKeyImages = async (dataa) => {
    try {
      const formData = {
        AwsBucket: AWS_Bucket_Name(),
        suid: `${Folder}${subFolder ? "/" + subFolder : ""}${
          thirdFolder ? "/" + thirdFolder : ""
        }${fourthFolder ? "/" + fourthFolder : ""}/${dataa}`,
      };

      const response = await axios.get(
        `${keyImages}/keyImages/v1/keyImages?SUID=${encodeURIComponent(
          formData.suid
        )}&AwsBucket=${encodeURIComponent(
          formData.AwsBucket
        )}`
      );

      if (response.data) {
        const keyImages = response.data.data.map((item) => ({
          src: `data:image/png;base64,${item.Body}`,
          createdAt: item.LastModified,
        }));

        setLoader(false);
        toggleImagesSidePanel(keyImages);
        // setApiData(response.data);
        setMessage("Folder Updated Successfully");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
      }

      console.log("Fetching key images for:", dataa);
    } catch (error) {
      console.error("Error fetching key images:", error);
    }
  };

  const toggleSidePanel = (data) => {
    setSsuid(data);
    setIsSidePanelOpen(!isSidePanelOpen);
  };

  const toggleImagesSidePanel = (data) => {
    setKeyImagesData(data);
    setImagesSidePanelOpen(!isImagesSidePanelOpen);
  };

  const getToken = async () => {
    try {
      const response = await axios.get(
        `${GetTokenApi}/fileloaderv1/files/GetTokenNew`
      );

      if (response.data) {
        return response.data.token;
      } else {
        console.error("Error: No data in response");
      }
    } catch (error) {
      console.error("Error fetching token:", error);
    }
  };

  const viewStudy = async (
    folderName,
    awsbucketname,
    awsAccessKeyId,
    awsSecretAccessKey,
    dcmcaccesskey,
    password
  ) => {
    dispatch(foldersave({ folder: folderName }));
    const base64 =
      process.env.React_App_AWS_Bucket_Name +
      "^" +
      process.env.React_App_User_AWS_Access_Key_Id +
      "^" +
      process.env.React_App_User_AWS_Secret_Access_Key +
      "^" +
      process.env.React_App_User_DCMC_Access_Key;
    // const token = await getToken();
    const base64String = btoa(base64);
    const url = `${ViewerURL}/xrad/viewer/${folderName}%5E${base64String}?Finalized=false`;
    setPassword(password);
    setIframeValue(url);
    setDisplayIFrame(true);

    // axios
    //   .post("https://key-images-vercel.vercel.app/api/v1/keyImages/base", {
    //     Foldername: folderName,
    //     Bucket_Name: awsbucketname,
    //     AccessKey_Id: awsAccessKeyId,
    //     SecretAccess_Key: awsSecretAccessKey,
    //     dcmcAccesskey: dcmcaccesskey,
    //   })
    //   .then(function (response) {
    //     //console.log(response.data.url);
    //     setPassword(password);
    //     setIframeValue(response.data.url);
    //     setDisplayIFrame(true);
    //   });
  };
  function FileUploadBox() {
    const [borderColor, setBorderColor] = useState("#d9d9d9");
    return (
      <div
        className="rounded-lg text-card-foreground shadow-sm h-full"
        style={{
          textAlign: "center",
          padding: "10px",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          border: `2px dashed ${borderColor}`,
          borderRadius: "8px",
          background: "#fafafa",
          cursor: "pointer",
        }}
        onMouseEnter={() => setBorderColor("#662583")} // Change border to purple on hover
        onMouseLeave={() => setBorderColor("#d9d9d9")} // Reset border on mouse leave
      >
        <div className="flex flex-col space-y-1.5 p-6">
          <h3 className="text-2xl font-semibold leading-none tracking-tight">
            Upload a Case
          </h3>
          <p className="text-sm text-muted-foreground">
            Upload a new case file to the system
          </p>
        </div>
        <div className="p-6 pt-0">
          <button
            onClick={() => setTab(1)}
            className="w-full bg-[#662583]  text-white py-2 px-4 rounded transition-colors"
          >
            Upload Case
          </button>
        </div>
      </div>
    );
  }

  function downloadFile(filePath) {
    var link = document.createElement("a");
    link.href = filePath;
    // link.target = "_blank"
    link.download = filePath.substr(filePath.lastIndexOf("/") + 1);
    link.click();
  }
  var pAccession;

  const statesL = useLocation();

  const clickHandler = async (item) => {
    // alert()
    const token = localStorage.getItem("token");

    let pName = item.patientName;
    let pModality = item.modalityType;

    let suid = item.SUID || "";

    const requestBody = {
      args: [suid],
      email: state.email,
      orgName: "dcm",
      fcn: "viewDicomFile",
    };

    try {
      const response = await axios.post(
        `${BlockChain}/api/view-dicom`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
    // let pAccession = item["00080050"]?item["00080050"].Value[0]:"N/A"?item["00080050"].Value[0]:'N/A';
    if (item.accession) {
      pAccession = item.accession;
    } else {
      pAccession = "N/A";
    }

    // ===Upload Data Hyperledge==
    axios
      .post(`http://192.168.18.19:8080/api/view/CLIENT${state.id}`, {
        patientName: pName,
        customerID: state.email,
        modality: pModality,
        accession: pAccession,
      })
      .then((response) => response.json())
      .then((result) => console.log("result", result))
      .catch((error) => console.log("error", error));
  };

  // ==== Share Data hyperledge===

  const DownloadStudy = async (data) => {
    let base64ToString = new Buffer.from(
      `${AWS_Bucket_Name()}^${AWS_Access_Key_Id_Encypt()}^${AWS_Secret_Access_Key_Encypt()}^null^null`
    ).toString("base64");
    const hello = await fetch(
      `${DRCoreApi}/react/WadoRS/studies/${data}^${base64ToString}/metadata`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const resp = await hello.json();
    if (resp) {
      resp.map(async (item) => {
        downloadFile(
          `${DRCoreApi}/react/WadoURI?requestType=WADO&studyUID=${item["0020000D"].Value[0]}&seriesUID=${item["0020000E"].Value[0]}&objectUID=${item["00080016"].Value[0]}&contentType=application/dicom&transferSyntax=*&key=QUtJQVVaUzU0NlBWRURTMlJSWVA=`
        );
      });
    }
  };

  const deleteStudy = (args) => {
    var data = [];
    //  localStorage.getItem("deleteStudy")
    if (!localStorage.getItem("deleteStudy")) {
      data.push(args);
      localStorage.setItem("deleteStudy", JSON.stringify(data));
      setMessage("Deleting Study...");
      setIsOpen(true);
      setTimeout(() => {
        setIsOpen(false);
        window.location.reload();
      }, 2000);
    } else {
      data = JSON.parse(localStorage.getItem("deleteStudy"));
      data.push(args);
      localStorage.setItem("deleteStudy", JSON.stringify(data));
      setMessage("Deleting Study...");
      setIsOpen(true);
      setTimeout(() => {
        setIsOpen(false);
        window.location.reload();
      }, 2000);
    }
  };
  const convertDate = (inputDate) => {
    // Extract year, month, and day from the inputDate string
    const year = inputDate.substring(0, 4);
    const month = inputDate.substring(4, 6);
    const day = inputDate.substring(6, 8);

    // Concatenate the year, month, and day in the ISO date format
    const isoDate = `${year}-${month}-${day}`;

    return isoDate;
  };

  const deleteCase = async (suid) => {
    setLoader(true);
    try {
      const body = {
        folderName: `${FolderName}${subFolder ? "/" + subFolder : ""}${
          thirdFolder ? "/" + thirdFolder : ""
        }${fourthFolder ? "/" + fourthFolder : ""}`,
        bucketName: AWS_Bucket_Name(),
        region: AWS_Region(),
        suid,
      };
      const response = await axios.post(
        `${UploadApi}/apiUpload/delete-case`,
        body
      );

      if (response.data && response.data.success) {
        setMessage("Study Deleted Successfully");
        setIsOpen(true);
        setTimeout(() => {
          setIsOpen(false);
        }, 2000);
      }
    } catch (error) {
      console.error(error);
    } finally {
      fetchStudies();
    }
  };

  const fetchStudies = async () => {
    setLoader(true);
    const formationOfData = [];
    let token = localStorage.getItem("token");
    let isShared = false;
    const value = localStorage.getItem("jkbnm");
    isShared = value === "dmewtnwkndghn" ? true : false;

    // if (!token) {
    //   token =
    //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY1YWI2MjhkNDdlZGQwZmQ0MjMyZjhmNSIsImlhdCI6MTcwNjYxOTI2NCwiZXhwIjoxNzM4MTU1MjY0fQ.IPPNUyR0I9ZnJ9IQfQPOBU3F-ZSteMEkJLpSw9WmDII";
    //   localStorage.setItem("token", token);
    // }
    // const formatedData = []
    try {
      const formData = new FormData();
      formData.append(
        "folderName",
        `${Folder}${subFolder !== undefined ? "/" + subFolder : ""}${
          thirdFolder !== undefined ? "/" + thirdFolder : ""
        }${fourthFolder !== undefined ? "/" + fourthFolder : ""}`
      );
      formData.append("bucketName", AWS_Bucket_Name());
      formData.append("Region", AWS_Region());

      const hello = await fetch(`${UploadApi}/apiUpload/GetData`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const resp = await hello.json();
      var studies = [];

      if (resp.data.length > 0) {
        setShowModalityWithoutLabs(true);
      }
      resp?.data.filter((item) => {
        if (
          state.email === "operations@medicalrecordcollation.com" ||
          "ziad@gmail.com" ||
          "danish@gmail.com"
        ) {
          formationOfData.push({
            ssuid: item?.SUID ? item.SUID : "",
            name: item?.patientName ? item.patientName : "N/A",
            mrn: item?.mrn ? item.mrn : "N/A",
            Accession: item?.accession ? item.accession : "",
            "Study Date": item.studyDate
              ? convertDate(item.studyDate)
              : // format(new Date( convertDate(item.studyDate)), "dd-MM-yyyy")
                "",
            modality: item?.modalityType ? item.modalityType : "",
            modalityLab: item["00081010"]
              ? item["00081010"].Value[0]
              : Folder[0],
            modalityDes: item?.modalityDescription
              ? item.modalityDescription
              : "Not Available",
            foldername: `${Folder}${
              subFolder != undefined ? "/" + subFolder : ""
            }${thirdFolder !== undefined ? "/" + thirdFolder : ""}${
              fourthFolder !== undefined ? "/" + fourthFolder : ""
            }`,
            action: (
              <>
                <>
                  {!isOnlyKeyImages && (
                    <Tooltip title="View Study  ">
                      <i
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          viewStudy(
                            item.SUID,
                            AWS_Bucket_Name(),
                            AWS_Access_Key_Id_Encypt(),
                            AWS_Secret_Access_Key_Encypt(),
                            process.env.React_App_User_DCMC_Access_Key_encypt,
                            item.patientName
                          );
                          //clickHandler(item);
                          navigate(
                            `/StudyTable/${Folder}/${
                              item.modalityType
                            }/${subFolder}${
                              thirdFolder ? "/" + thirdFolder : ""
                            }${fourthFolder ? "/" + fourthFolder : ""}`
                          );
                          setTab(0);
                          setDisplayIFrame(true);
                        }}
                      >
                        <RemoveRedEyeIcon />
                      </i>
                    </Tooltip>
                  )}
                  &nbsp;
                  {(!FolderGet || CanUpload) && !isOnlyKeyImages && (
                    <>
                      <Tooltip title="Upload PDF">
                        <i
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            let bNAme = AWS_Bucket_Name();
                            let Sckey = AWS_Secret_Access_Key_Encypt();
                            let Ackey = viewStudy(
                              item.SUID,
                              bNAme,
                              process.env
                                .React_App_User_AWS_Access_Key_Id_encypt,
                              Sckey,
                              process.env.React_App_User_DCMC_Access_Key_encypt,
                              item.patientName
                            );
                            // clickHandler(item);

                            addLabs(
                              item.modalityType ? item.modalityType : "",
                              FolderName,
                              item.SUID
                            );
                          }}
                        >
                          <UploadIcon />
                        </i>
                      </Tooltip>
                    </>
                  )}
                  &nbsp;
                  <i
                    className={`${
                      item.isDocument ? "cursor-pointer" : "cursor-not-allowed"
                    }`}
                    // style={{ cursor: "pointer" }}
                    onClick={() => {
                      var email = item.patientName;
                      var pass = item.accession
                        ? item.accession
                        : item.patientName;
                      var dataa = item.SUID;
                      // setCAccession(data);
                      // setCEmail(email);
                      // setCPass(pass);
                      if (item.isDocument) {
                        fetchDataFromApi(dataa);
                      }
                    }}
                  >
                    <Tooltip title="View Document">
                      <SimCardDownloadIcon style={{ color: "red" }} />
                    </Tooltip>
                  </i>
                  &nbsp;
                  {/* {!FolderGet && ( */}
                    <Tooltip title="Download Study">
                      <GetAppIcon
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={(e) => downloadDicom(item.SUID, e)}
                      />
                    </Tooltip>
                  &nbsp;
                  <i
                    className={`cursor-pointer`}
                    // style={{ cursor: "pointer" }}
                    onClick={() => {
                      var email = item.patientName;
                      var pass = item.accession
                        ? item.accession
                        : item.patientName;
                      var dataa = item.SUID;
                      // setCAccession(data);
                      // setCEmail(email);
                      // setCPass(pass);
                      fetchKeyImages(dataa);
                    }}
                  >
                    <Tooltip title="View Key Images">
                      <Image style={{ color: "red" }} />
                    </Tooltip>
                  </i>
                  &nbsp;
                  {!isShared && (
                    <Tooltip title="Delete Case">
                      <Delete
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => deleteCase(item.SUID)}
                      />
                    </Tooltip>
                  )}
                  {/* )} */}
                </>
              </>
            ), // Set to "Not Available" if it doesn't exist
          });
          setformation(formationOfData);

          const filteredData = formationOfData?.filter(
            (e, i) => e?.modalityLab === cleanedValue
          );
          const filteredData2 = [];
          const encounteredModalityLabs = new Set();

          for (const item of filteredData) {
            if (!encounteredModalityLabs.has(item.modality)) {
              encounteredModalityLabs.add(item.modality);
              filteredData2.push(item);
              setFilter(filteredData2);
              setMainFolder(true);
            }
          }

          //   setformation(prevFormation => [...prevFormation,{name: item["00100010"] ? item["00100010"].Value[0].Alphabetic : "",
          //   mrn: item["00100020"] ? item["00100020"].Value[0] : "",
          //   Accession: item["00080050"] ? item["00080050"].Value[0] : "",
          //   "Study Date": item["00080020"] ? item["00080020"].Value[0] : "",
          //   modality: item["00080060"] ? item["00080060"].Value[0] : "",
          //   modalityLab: item["00081010"] ? item["00081010"].Value[0] : "Not Available",
          // }])
        }
      });
      if (formationOfData.length != 0) {
        dispatch(setbuttonTop(true));
        setMainFolder(true);
      }

      //       setStudies(formatedData);
      //       //console.log(formatedData,"formatedDatas");
    } catch (error) {
      setShowModalityWithoutLabs(false);
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  // check before delete
  const fetchStudiesdel = async (name) => {
    // setLoader(true);
    const formationOfData = [];
    let token = localStorage.getItem("token");
    // if (!token) {
    //   token =
    //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY1YWI2MjhkNDdlZGQwZmQ0MjMyZjhmNSIsImlhdCI6MTcwNjYxOTI2NCwiZXhwIjoxNzM4MTU1MjY0fQ.IPPNUyR0I9ZnJ9IQfQPOBU3F-ZSteMEkJLpSw9WmDII";
    //   localStorage.setItem("token", token);
    // }
    // const formatedData = []
    try {
      const formData = new FormData();
      formData.append("folderName", `${Folder}/${name}`);
      formData.append("bucketName", AWS_Bucket_Name());
     
      formData.append("Region", process.env.React_App_AWS_Region);

      const hello = await fetch(`${UploadApi}/apiUpload/GetData`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const resp = await hello.json();
      // //console.log(resp, "wwwww2");

      if (resp?.success) {
        setStudiesHave(false);
        setRandom(!random);
        setDeleteName(`${Folder}/${name}`);
      } else {
        setRandom(!random);
        setStudiesHave(true);
      }
      setDeleteName(`${Folder}/${name}`);
      // setLoader(false);
    } catch (error) {
      //console.log(error);
      // setLoader(false);
    }
  };
  const SubFolderGet = async () => {
    setFolderLoader(true);
    setFolderList([]);
    let token = localStorage.getItem("token");
    // if (!token) {
    //   token =
    //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY1YWI2MjhkNDdlZGQwZmQ0MjMyZjhmNSIsImlhdCI6MTcwNjYxOTI2NCwiZXhwIjoxNzM4MTU1MjY0fQ.IPPNUyR0I9ZnJ9IQfQPOBU3F-ZSteMEkJLpSw9WmDII";
    //   localStorage.setItem("token", token);
    // }
    try {
      let response = await fetch(
        `${FileLoader}/fileloaderv1/files/GetSubFolder?awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt()
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt()
        )}&bucketName=${AWS_Bucket_Name()}&folderName=${`${Folder}${
          subFolder ? "/" + subFolder : ""
        }${thirdFolder ? "/" + thirdFolder : ""}`}&Region=${AWS_Region()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let res = await response.json();

      if (res.status === 401) {
        localStorage.removeItem("token");
        navigate("/signin");
      }

      const filteredRes = res.filter((element) => !element.includes("."));
      setFolderList(filteredRes);
      setFilteredSubList(filteredRes);
      if (filteredRes.length != 0) {
        setHide(true);
        dispatch(setbuttonTop(false));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setFolderLoader(false);
    }
  };

  // React.useEffect(() => {
  //   if (prevLocationRef.current && prevLocationRef.current.pathname !== location.pathname) {
  //     // Handle back button click or browser navigation
  //     //console.log('Back button clicked or browser navigation');
  //     // Add your custom functionality here
  //   }
  //   prevLocationRef.current = location;
  // }, [location]);

  React.useEffect(() => {
    setFolderList([]);
    setformation([]);
    setFilter([]);
    setMainFolder(false);
    if (fourthFolder) {
      if (fourthFolder != undefined) {
        fetchStudies();
        // getData();
      }
    } else {
      fetchStudies();
      SubFolderGet();
      // getData();
    }
  }, [subFolder, thirdFolder, RefreshLoader, fourthFolder]);

  const [counterFilter, setCounterFilter] = useState(0);
  React.useEffect(() => {
    if (counterFilter > 0) {
      const tempList = sortedFolderList.filter((item) =>
        item.toLowerCase().includes(filterValue.toLowerCase())
      );
      setFilteredSubList(tempList);

      if (tempList.length == 0) {
        cogoToast.error("No folders exist", {
          position: "top-right",
        });
        setFilteredSubList(sortedFolderList);
      }
    } else {
      setCounterFilter(1);
    }
  }, [filterValue]);

  const deleteNow = async (name) => {
    try {
      let token = localStorage.getItem("token");
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      let formData = {
        AwsBucket: AWS_Bucket_Name(),
        FolderName: `${Folder}${subFolder ? "/" + subFolder : ""}${
          thirdFolder ? "/" + thirdFolder : ""
        }/${name}/`,
        UserName: state.email,
      };

      let response = await axios.post(
        // "https://app.dcmcloud.com/keyImages/v1/updateFolder/deleteFolder",
        `${keyImages}/keyImages/v1/updateFolder/moveToArchive`,
        JSON.stringify(formData),
        { headers }
      );

      if (response) {
        setIsOpen(true);
        setMessage("Folder deleted Successfully");
        setSeverty("error");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
        // cogoToast.success("Folder Delete successfully.", { position: "top-right" });
        await fetchStudies();
        await SubFolderGet();
      }
    } catch (error) {
      setIsOpen(true);
      setMessage("Failed to Delete");
      setSeverty("error");
      setTimeout(() => {
        setIsOpen(false);
      }, 3000);
      console.error("Error while deleting folder:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleMouseEnter = () => {
    document.querySelector(".nonedisplay").style.display = "inline";
  };

  const addLabs = (modality, FolderName, ssuid) => {
    // const currentPathname = location.pathname;

    try {
      navigate(
        `/Upload/${FolderName}${subFolder != undefined ? "/" + subFolder : ""}${
          thirdFolder !== undefined ? "/" + thirdFolder : ""
        }${
          fourthFolder !== undefined ? "/" + fourthFolder : ""
        }/${modality}/${ssuid}`
      );
      setTab(1);
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  const handleMouseLeave = () => {
    document.querySelector(".nonedisplay").style.display = "none";
  };

  const DeleteFolder = async (name) => {
    // if (window.confirm(`Are you sure you want to delete "${name}"`)) {
    //   await fetchStudiesdel(name);

    //   // //console.log(subfoldersHave, "subfoldersHave");
    // } else return;
    setLoader(true);
    deleteNow(name);
  };

  const EditedFolder = async (name) => {
    const specialCharPattern = /[^a-zA-Z0-9._-\s]/;

    // Check if emailValue contains any special characters
    if (specialCharPattern.test(EditValue)) {
      cogoToast.error("Sorry, the use of special symbols is not allowed.", {
        position: "top-right",
        hideAfter: 5,
      });
      return;
    }
    if (!EditValue.trim()) {
      cogoToast.error("Folder name cannot be empty", {
        position: "top-right",
        hideAfter: 5,
      });
      console.error("Folder name cannot be empty");
      return;
    }
    if (sortedFolderList.includes(EditValue)) {
      cogoToast.error("Folder name already exist", {
        position: "top-right",
        hideAfter: 5,
      });
      console.error("Folder name already exist");
      return;
    }
    setLoader(true);
    try {
      let token = localStorage.getItem("token");

      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      let formData = {
        AwsBucket: AWS_Bucket_Name(),
        oldKey:
          Folder +
          `${subFolder ? "/" + subFolder : ""}` +
          `${thirdFolder ? "/" + thirdFolder : ""}` +
          "/" +
          oldKey +
          "/",
        newKey:
          Folder +
          `${subFolder ? "/" + subFolder : ""}` +
          `${thirdFolder ? "/" + thirdFolder : ""}` +
          "/" +
          EditValue +
          "/",
      };

      let response = await axios.post(
        `${keyImages}/keyImages/v1/updateFolder/updateFolder`,
        JSON.stringify(formData),
        { headers }
      );

      if (response) {
        setIsOpen(true);
        setMessage("Folder Edit Successfully");
        setSeverty("success");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
        setEditModal(false);
        await fetchStudies();
        await SubFolderGet();
      }
    } catch (error) {
      setIsOpen(true);
      setMessage("Edit Folder Failed.");
      setSeverty("error");
      setTimeout(() => {
        setIsOpen(false);
      }, 3000);
      setEditModal(false);
      console.error("Error while deleting folder:", error);
    } finally {
      setLoader(false);
    }
  };

  const createFolder = async () => {
    // setOpenFolder(false);
    const specialCharPattern = /[^a-zA-Z0-9._-\s]/;

    setLoader(true);
    dispatch(setModalFolder(false));
    setCreteFolder([...createfoler, { name: emailValue }]);
    if (emailValue == null || emailValue == "" || emailValue == " ") {
      cogoToast.error("Folder name cannot be empty", {
        position: "top-right",
        hideAfter: 5,
      });
      setLoader(false);
      dispatch(setModalFolder(true));
    } else if (sortedFolderList.includes(emailValue.trim())) {
      cogoToast.warn("Folder Already Exists", {
        position: "top-right",
        hideAfter: 5,
      });
      setLoader(false);
      dispatch(setModalFolder(true));
      return;
    } else if (emailValue.length > 200) {
      // alert("Folder Name must be less than 25 letters");
      // return;
      setLoader(false);
      setErrorMassage("Folder Name must be less than 200 characters");
      dispatch(setModalFolder(true));
    } else if (specialCharPattern.test(emailValue)) {
      cogoToast.error("Sorry, the use of special symbols is not allowed.", {
        position: "top-right",
        hideAfter: 5,
      });
      setLoader(false);
      dispatch(setModalFolder(true));
    } else {
      try {
        const token = localStorage.getItem("token");
        const formData = new FormData();
        formData.append("awsbucketname", AWS_Bucket_Name());
        formData.append("awsAccessKeyId", AWS_Access_Key_Id_Encypt());
        formData.append("awsSecretAccessKey", AWS_Secret_Access_Key_Encypt());
        formData.append("Region", AWS_Region());
        formData.append(
          "DCMCAccessKey",
          process.env.React_App_User_DCMC_Access_Key_encypt
        );

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        };

        let res = await axios.post(
          `${FileLoader}/fileloaderv1/files/FolderCreate?UserAccessKey=WO0OZEHTOGFYN9Z6&UserSecretAccessKey=OYTZHWZY6TZTO0NFINK01IC4IEJL43BV&FolderName=${Folder}${
            subFolder ? "/" + subFolder : ""
          }${
            thirdFolder ? "/" + thirdFolder : ""
          }/${emailValue.trim()}&Location=${
            Intl.DateTimeFormat().resolvedOptions().timeZone
          }&Username=${state.email}`,
          formData,
          { headers }
        );
        if (res.data?.CreationTime) {
          setErrorMassage("");
          setIsOpen(true);
          setMessage("Folder Created Successfully");
          setSeverty("success");
          setTimeout(() => {
            setIsOpen(false);
          }, 3000);
        } else {
          cogoToast.warn("Folder Already Exists", {
            position: "top-right",
            hideAfter: 5,
          });
        }
        // Fetch studies after creating the folder
        await fetchStudies();
        await SubFolderGet();
        // await fetchStudiesTwo();
      } catch (error) {
        setIsOpen(true);
        setMessage("Failed to create folder !!");
        setSeverty("error");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
        console.error("Error:", error);
      } finally {
        setLoader(false);
      }
    }
  };

  const match = Folder.find((item) => item.includes("--ONLYSHARE--")) || "";
  const result = match ? match.split("--ONLYSHARE--")[0] : Folder;

  const determinePath = (item) => {
    try {
      if (FolderGet) {
        const parts = FolderGet.split("/");
        const count = parts.length;
        const lastPart = parts[parts.length - 1];

        const hierarchies = [result?.[0], subFolder, thirdFolder, fourthFolder];

        // Slice from count, but filter out undefined or null
        const remaining = hierarchies.slice(count).filter(Boolean);

        // Build new path safely
        const newPath = [lastPart.split("--ONLYSHARE--")[0], ...remaining]
          .filter(Boolean)
          .join("/");
        return item ? `${newPath}/${item}` : newPath;
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <>
        <CustomizedSnackbars
          isOpen={isOpen}
          severity={severity}
          message={message}
        />
        <AlertDialogSlide3
          cOpen={cOpen1}
          setCOpen={setCOpen1}
          email={shareFolderName}
        />
        <div style={{ background: "rgba(0, 0, 0, 0.12)", marginTop: "-10px" }}>
          <Dialog
            open={modalFolder}
            PaperProps={{
              style: {
                height: "200px",
              },
            }}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle style={{ margin: "auto", color: "#1976D2" }}>
              {"New Sub Folder"}
            </DialogTitle>
            <DialogContent style={{ overflowX: "hidden", marginLeft: 5 }}>
              <DialogContentText id="alert-dialog-slide-description">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                    <Grid item lg={12} style={{ paddingLeft: 23 }}>
                      <br />
                      <TextField
                        onChange={(e) => {
                          setEmailValue(e.target.value);
                          setErrorMassage("");
                        }}
                        autoFocus
                        hiddenLabel
                        required
                        label="Sub Folder Name"
                        variant="outlined"
                        size="small"
                        type={"text"}
                        style={{
                          borderRadius: "3px",
                          backgroundColor: "white",
                          width: 538,
                          marginTop: "5px",
                        }}
                      />
                      {ErrorMassage && (
                        <p className="text-red-600">{ErrorMassage}</p>
                      )}
                    </Grid>
                  </Grid>
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions
              style={{ marginRight: "22px", marginBottom: "10px" }}
            >
              <Button
                onClick={() => {
                  dispatch(setModalFolder(false));
                  setErrorMassage("");
                  setLoader(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  createFolder();
                  // setLoader(false);
                }}
              >
                Create
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* Edit Folder Name Modal */}
        <div style={{ background: "rgba(0, 0, 0, 0.12)", marginTop: "-10px" }}>
          <Dialog
            open={EditModal}
            // style={{ height: "70%" }}
            PaperProps={{
              style: {
                height: "250px",
              },
            }}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle style={{ margin: "auto", color: "#1976D2" }}>
              {"Edit "}
            </DialogTitle>
            <DialogContent style={{ overflow: "hidden", marginLeft: 5 }}>
              <DialogContentText id="alert-dialog-slide-description">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                    <Grid item lg={12} style={{ paddingLeft: 23 }}>
                      <br />
                      <span>
                        *Editing the folder name will expire the shared links.
                        Please re-share the links.
                      </span>
                      <TextField
                        onChange={(e) => setEditValue(e.target.value)}
                        autoFocus
                        hiddenLabel
                        required
                        label="Folder Name"
                        variant="outlined"
                        size="small"
                        value={EditValue}
                        type={"text"}
                        style={{
                          borderRadius: "3px",
                          backgroundColor: "white",
                          width: 538,
                          marginTop: "10px",
                        }}
                      />
                    </Grid>
                  </Grid>
                </div>
              </DialogContentText>
            </DialogContent>

            <DialogActions
              style={{ marginRight: "22px", marginBottom: "10px" }}
            >
              <Button onClick={() => setEditModal(false)}>Cancel</Button>
              <Button
                variant="contained"
                onClick={() => {
                  EditedFolder();
                  // createFolder();
                  // setLoader(false);
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <div
          className="flex justify-center space-x-2"
          style={{
            // marginBottom: "50px",
            display: "flex",
            justifyContent: "space-evenly",
          }}
        >
          <SidePanel
            isOpen={isSidePanelOpen}
            onClose={toggleSidePanel}
            ssuidDetail={ssuid}
          />
          <ImagesSidePanel
            isOpen={isImagesSidePanelOpen}
            onClose={toggleImagesSidePanel}
            ssuidDetail={keyImagesData}
          />
          <div className="flex w-[92%] lg:w-full md:w-full sm:w-full text-xs md:test-sm text-purple-800 bg-white border hiii h-12 rounded-xl mb-4 shadow-md">
            <div className="inline-flex md:w-full h-full">
              <Tooltip title="Back">
                <div
                  className="flex cursor-pointer mx-3 items-center"
                  onClick={goBack}
                >
                  {" "}
                  <img src={LeftArrow} height="20px" width="20px" alt="img" />
                </div>
              </Tooltip>

              <Tooltip
                title={
                  FolderGet && !match.includes("--ONLYSHARE--")
                    ? determinePath(null)
                    : `${result}${subFolder ? "/" + subFolder : ""}${
                        thirdFolder ? "/" + thirdFolder : ""
                      }${fourthFolder ? "/" + fourthFolder : ""}`
                }
              >
                <div className="flex cursor-pointer font-bold items-center">
                  {" "}
                  <img
                    src={FOLDER}
                    className="mx-2"
                    height="20px"
                    width="20px"
                    alt="img"
                  />
                  <p
                    className="flex my-auto"
                    onClick={() => {
                      navigate(`/`);
                      setTab(0);
                    }}
                  >
                    My Folder
                  </p>
                  /
                  {FolderGet && !match.includes("--ONLYSHARE--") ? (
                    determinePath(null)
                  ) : (
                    <>
                      <p
                        className="flex my-auto"
                        onClick={() => {
                          navigate(`/SubFolder&studies/${Folder}`);
                          // setToggle(true);
                        }}
                      >
                        {result}
                      </p>
                      {subFolder ? "/" + subFolder : null}
                      {thirdFolder ? "/" + thirdFolder : null}
                      {fourthFolder ? "/" + fourthFolder : null}
                    </>
                  )}
                </div>
              </Tooltip>
            </div>
            <div className="flex w-1/2 float-right justify-end p-4 ">
              {(!FolderGet || CanUpload) &&
                !isOnlyKeyImages &&
                !hide &&
                !Folder?.some((f) => f.includes("--ONLYSHARE--")) && (
                  <>
                    <div
                      className="flex cursor-pointer font-bold text-xs items-center mr-2"
                      onClick={() => setTab(1)}
                    >
                      {" "}
                      <img
                        src={checkBox}
                        className="mx-2"
                        height="20px"
                        width="20px"
                        alt="img"
                      />
                      Add Case
                    </div>
                  </>
                )}
              {showModalityWithoutLabs ? (
                <div className="md:px-3 flex font-bold items-center">
                  <Switch
                    {...label}
                    onClick={() => {
                      dispatch(setbuttonTop(true));
                      setToggle(!toggle);
                      // ShowTable(!toggle);
                    }}
                    checked={toggle}
                  />
                  <label className="hidden md:flex pt-2">{labelValue}</label>
                </div>
              ) : null}
              {!mainFolder && !fourthFolder && formation.length === 0 ? (
                <Tooltip title="Create Sub Folder" placement="bottom">
                  <div
                    className=" flex justify-center items-center bg-[#c48bde] h-8 w-8 rounded-lg  right-16 "
                    style={{
                      visibility: !FolderGet ? "visible" : "hidden",
                    }}
                    alt="img"
                    onClick={
                      filesLength > 0
                        ? null
                        : () => dispatch(setModalFolder(true))
                    }
                  >
                    <img src={imglogo} className="h-5 cursor-pointer" />
                  </div>
                </Tooltip>
              ) : null}
            </div>
          </div>
        </div>
        {loader || folderLoader ? (
          <div className="my-20">
            {" "}
            <Loader />
          </div>
        ) : (
          <>
            {formation.length != 0 && toggle ? (
              //  <DatatablePage data={formation} setopen={setopen} />
              <div className="w-full mx-auto ">
                <div className=" flex justify-center items-center mx-auto w-full ">
                  <div className=" w-11/12 mx-auto">
                    {" "}
                    <DatatablePage
                      data={formation}
                      setopen={setopen}
                      setformation={setformation}
                      goBack={goBack}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="flex justify-center w-full ">
                  <div className="flex flex-col justify-center items-center w-full ">
                    <div
                      className="flex flex-col md:flex-row flex-wrap max-w-7xl justify-start items-center w-full gap-2"
                      style={{
                        height: `${"auto"}`,
                        marginTop: `${"0"}`,
                      }}
                    >
                      {sortedFolderList?.length !== 0
                        ? filteredSubList?.map((item) => (
                            <Tooltip
                              title={
                                FolderGet && !match.includes("--ONLYSHARE--")
                                  ? determinePath(item)
                                  : `${Folder}${
                                      subFolder ? " / " + subFolder : ""
                                    }${thirdFolder ? " / " + thirdFolder : ""}${
                                      item ? " / " + item : ""
                                    }`
                              }
                            >
                              <Card
                                className=" admin-card w-full sm:w-[45%] md:w-[35%] lg:w-[30%] xl:w-[23%] mb-3"
                                key={item.clientHandler}
                              >
                                <div
                                  className="admin-card-contnet"
                                  style={{
                                    display: "flex",
                                    position: "relative",
                                    flexDirection: "column",
                                  }}
                                >
                                  {/* {//console.log("Data is running", item)} */}
                                  <CardContent className="px-2 py-3">
                                    {/* <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        position: "relative",
                                        overflow: "hidden",
                                        // width: "250px",
                                        //  to control the container
                                      }} */}
                                    <div
                                      className="w-[100px] m-auto mb-2"
                                      onClick={() =>
                                        thirdFolder
                                          ? saveStudyData(item, "#####")
                                          : subFolder
                                          ? saveStudyData(item, "####")
                                          : saveStudyData(item, "###")
                                      }
                                      onMouseEnter={() =>
                                        setHoveredFolder(item)
                                      }
                                      onMouseLeave={() =>
                                        setHoveredFolder(null)
                                      }
                                    >
                                      <img
                                        className="imgLabs"
                                        src={
                                          hoveredFolder === item
                                            ? FolderImg2
                                            : FolderImg1
                                        }
                                        alt="Your Image"
                                        style={{
                                          //  width: "100px",
                                          // height: "85px",
                                          //   marginBottom: "5px",
                                          transition: "transform 0.3s ease",
                                          transform:
                                            hoveredFolder === item
                                              ? "scale(1.1)"
                                              : "scale(1)",
                                          filter:
                                            hoveredFolder === item
                                              ? "none"
                                              : "none",
                                        }}
                                      />
                                    </div>
                                    <div className="flex flex-col items-center text-center">
                                      {/* <div
                                      className=""
                                      style={{
                                        // textAlign: "center",
                                        margin: "20px",
                                        marginLeft: "30px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        position: "absolute",
                                        padding: "10px",
                                        top: "70%",
                                        left: "36%",
                                        // width: "500px",
                                        transform: "translate(-50%, -50%)",
                                      }}
                                    > */}
                                      {/* <span>{item.split(" ").slice(2).join(" ")}</span> */}
                                      {/* <span
                                        style={{
                                          padding: "50px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                        className="flex"
                                      > */}
                                      {/* {item.split(" ").slice(0, 2).join(" ")} */}
                                      <span
                                        className="w-full text-sm overflow-hidden font-medium FontFamilyGilroy"
                                        style={{
                                          // padding: "50px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {item}
                                      </span>
                                      <span
                                        // style={{cursor:"pointer"}}
                                        className="m-1 flex  cursor-pointer float-right"
                                      >
                                        {!FolderGet && (
                                          <Tooltip
                                            title="Edit"
                                            onClick={() => {
                                              setEditModal(true);
                                              setEditValue(item);
                                              setOldKey(item);
                                            }}
                                          >
                                            <MdEdit className="h-5 w-5 text-gray-700" />
                                          </Tooltip>
                                        )}
                                        {!FolderGet || canShare ? (
                                          <Tooltip
                                            title="Share"
                                            onClick={() => {
                                              setCOpen1(true);
                                              setShareFolderName(
                                                `${Folder}${
                                                  subFolder
                                                    ? "/" + subFolder
                                                    : ""
                                                }${
                                                  thirdFolder
                                                    ? "/" + thirdFolder
                                                    : ""
                                                }/${item}`
                                              );
                                            }}
                                          >
                                            <IoMdShare className="h-5 w-5" />{" "}
                                          </Tooltip>
                                        ) : (
                                          ""
                                        )}
                                        {!FolderGet && (
                                          <Tooltip
                                            title="Delete"
                                            onClick={() => DeleteFolder(item)}
                                          >
                                            <MdDelete className="h-5 w-5 text-gray-700" />
                                          </Tooltip>
                                        )}
                                      </span>
                                      {/* </span> */}
                                    </div>
                                  </CardContent>
                                </div>
                              </Card>
                            </Tooltip>
                          ))
                        : null}
                      {/* {ifTime && (
                        <div className="fixed bottom-0 left-20">
                          Last Updated Time : {ifTime.formattedDate}{" "}
                          {ifTime.formattedTime}
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
                <div className="flex justify-center w-full">
                  <div className="flex flex-col justify-center items-center w-full ">
                    <div
                      className="flex flex-col md:flex-row flex-wrap max-w-7xl justify-center items-center w-full gap-2"
                      style={{
                        height: `${"auto"}`,
                        marginTop: `${"0"}`,
                      }}
                    >
                      {Filter === null ? (
                        <div
                          style={{
                            textAlign: "center",
                            height: "30vh",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <p style={{ fontSize: "14px", color: "gray" }}>
                            Loading...
                          </p>
                        </div>
                      ) : (
                        <Box
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            margin: "auto",
                            justifyContent: "center",
                          }}
                          className="adj-width"
                        >
                          {Filter.length !== 0
                            ? Filter.map((e, i) =>
                                e.modality != "" ? (
                                  <Tooltip
                                    title={`${Folder}${
                                      e.modality ? "/" + e.modality : ""
                                    }`}
                                  >
                                    <Card
                                      className="admin-card sm:w-45% md:w-35% lg:w-30% xl:w-23% w-44 mb-3"
                                      onClick={() =>
                                        saveStudyData(
                                          e?.modality,
                                          e?.modalityLab
                                        )
                                      }
                                      key={i}
                                      style={{
                                        width: "160px",
                                      }}
                                    >
                                      <div
                                        className="admin-card-contnet"
                                        style={{
                                          display: "flex",
                                          position: "relative",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <CardContent
                                          sx={{
                                            paddingBottom: "0px",
                                            padding: "4px",
                                          }}
                                        >
                                          <div className="card-head-wrapper">
                                            <div className="image-container">
                                              <img
                                                className="imgLabs"
                                                src={imga}
                                                alt="Your Image"
                                                style={{
                                                  width: "100px",
                                                  height: "85px",
                                                  marginBottom: "20px",
                                                  transition:
                                                    "transform 0.3s ease",
                                                }}
                                              />
                                            </div>
                                          </div>
                                          {/* fetching Path Name here  */}
                                          <div
                                            style={{
                                              textAlign: "center",
                                              margin: "20px",
                                              marginLeft: "30px",
                                              display: "flex",
                                              flexDirection: "column",
                                              alignItems: "center",
                                              position: "absolute",
                                              // padding: "10px",
                                              top: "70%",
                                              left: "40%",
                                              // width: "500px",
                                              transform:
                                                "translate(-50%, -50%)",
                                            }}
                                          >
                                            <span
                                              style={{
                                                padding: "50px",
                                                width: 300,
                                                overflow: "hidden",
                                              }}
                                            >
                                              {e?.modality}
                                            </span>
                                          </div>
                                        </CardContent>
                                      </div>
                                    </Card>
                                  </Tooltip>
                                ) : null
                              )
                            : null}
                        </Box>
                      )}
                      {Filter.length == 0 && sortedFolderList.length == 0 ? (
                        /* <div
                          style={{
                            textAlign: "center",
                            height: "30vh",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Empty description={false} />
                          <p style={{ fontSize: "14px", color: "gray" }}>
                            No Record Found!
                           // { <a onClick={() => setTab(1)}> Click Here </a> }
                          </p>
                        </div>
                        */
                        canShare &&
                        (FolderGet?.includes("--ONLYSHARE--") ||
                          Folder?.[0].includes("--ONLYSHARE--") ||
                          Folder?.includes("--ONLYSHARE--")) ? (
                          <div className="h-[50dvh] flex items-center justify-center">
                            <div className="text-center p-6 rounded-xl bg-gray-50 shadow-sm border border-dashed border-gray-700 max-w-lg mx-auto">
                              <p className="text-2xl font-semibold text-gray-700">
                                📁 No files yet
                              </p>
                              <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                                This folder will display copied files once they
                                become available.
                              </p>
                            </div>
                          </div>
                        ) : FolderGet && !CanUpload ? (
                          <div className="h-[50dvh] flex items-center justify-center">
                            <div className="text-center p-6 rounded-xl bg-gray-50 shadow-sm border border-dashed border-gray-700 max-w-lg mx-auto">
                              <p className="text-2xl font-semibold text-gray-700">
                                📁 No files yet
                              </p>
                              <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                                This folder will display files once they become
                                available.
                              </p>
                            </div>
                          </div>
                        ) : (
                          <div>
                            {!fourthFolder || (
                              <UploadFiles
                                setTab={setTab}
                                fetchStudies={fetchStudies}
                                isGrid={false}
                              />
                            )}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                              {!fourthFolder && (
                                <UploadFiles
                                  setTab={setTab}
                                  fetchStudies={fetchStudies}
                                  isGrid={true}
                                  goBackGrid={goBack}
                                />
                              )}
                              {!fourthFolder && <SubfolderBox />}
                            </div>
                          </div>
                        )
                      ) : null}
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )}
        <CustomizedSnackbars
          isOpen={isOpen}
          severity={severity}
          message={message}
        />
      </>
    </>
  );
}

function SubfolderBox() {
  const dispatch = useDispatch();
  const files = useSelector((state) => state.fileLength);
  const [borderColor, setBorderColor] = useState("#d9d9d9");
  return (
    <div
      className="rounded-lg  text-card-foreground shadow-sm h-full"
      style={{
        textAlign: "center",
        padding: "10px",
        height: "87.5%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        border: `2px dashed ${borderColor}`,
        borderRadius: "8px",
        background: "#fafafa",
        cursor: "pointer",
      }}
      onClick={files > 0 ? null : () => dispatch(setModalFolder(true))}
      onMouseEnter={() => setBorderColor("#662583")} // Change border to purple on hover
      onMouseLeave={() => setBorderColor("#d9d9d9")} // Reset border on mouse leave
    >
      <div className="flex flex-col space-y-1.5 p-6">
        <h3 className="text-2xl font-semibold leading-none tracking-tight">
          Create Sub Folder
        </h3>
        <p className="text-sm text-muted-foreground">
          Click on the icon to create a sub Folder
        </p>
      </div>
      <div className="p-6 pt-0">
        <div className="flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center p-6  cursor-pointer hover:bg-gray-50 transition-colors w-40 h-40 mx-auto">
            <div className="w-16 h-16 text-purple-600 mb-4">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 20h16a2 2 0 002-2V8a2 2 0 00-2-2h-7.93a2 2 0 01-1.66-.9l-.82-1.2A2 2 0 007.93 3H4a2 2 0 00-2 2v13c0 1.1.9 2 2 2z" />
                <path d="M12 10v6" />
                <path d="M9 13l3-3 3 3" />
              </svg>
            </div>
            <span className="text-sm font-medium text-center">
              Create SubFolder
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
